$(function () {
    // jQuery
    if ($('#dropzonePost').length) {
        var dropzonePost = new Dropzone("div#dropzonePost", {
            url: url + "/post/upload_photo",
            thumbnailWidth: 94,
            success: function (file, dataUrl) {
                file.photo_id = dataUrl;
            },
            headers: {
                'X-CSRF-Token': $('input[name="_token"]').val()
            },
            addRemoveLinks: true
        });
    }

    $('button[name="postText"]').on('click', send_post);
    $('button[name="post_goal"]').on('click', send_post_goal);
    $('#showDropzonePost').on('click', show_dropzone_post);

    function show_dropzone_post(e) {
        e.preventDefault();

        //$(".share-widget-action-photo").toggle();

        if ($(".share-widget-action-photo").is(':visible')) {
            $(".share-widget-action-photo").slideUp();
        } else {
            $(".share-widget-action-photo").slideDown();
        }
    }

    function send_post(e) {
        e.preventDefault();

        var form = $("#textPost ");

        $('textarea[name="message"]', form).attr('disabled', true);
        $('button[name="postText"]').attr('disabled', true);

        var photo_ids = [];
        $.each(dropzonePost.getAcceptedFiles(), function (index, value) {
            photo_ids.push(value.photo_id);
        });

        dropzonePost.removeAllFiles();

        $.post("/post/send",
            {
                '_token': $('input[name="_token"]', form).val(),
                '_user_id': $('input[name="_user_id"]', form).val(),
                'photo_ids': photo_ids,
                'message': $('textarea[name="message"]', form).val(),
            },
            function (response) {

                $('textarea[name="message"]', form).val('').attr('disabled', false);
                $('button[name="postText"]').attr('disabled', false);
                $(".share-widget-action-photo").slideUp();

                if (response.success == false) {
                    systemalert(response.message, 'warning');
                }

            }.bind(this),
            'json'
            )
            .fail(function () {
                $(this).attr('disabled', false);
                systemalert('There was an system error, please notify an admin!', 'danger');
            })
    }

    function send_post_goal(e) {
        e.preventDefault();

        var url = window.location.href;
        var segments = url.split('/');
        var goal_slug = segments[5];

        var form = $(this).parents('form');

        $('textarea[name="message"]', form).attr('disabled', true);
        $('button[name="post_goal"]').attr('disabled', true);

        var photo_ids = [];
        $.each(dropzonePost.getAcceptedFiles(), function (index, value) {
            photo_ids.push(value.photo_id);
        });

        dropzonePost.removeAllFiles();

        $.post("/post/send/goal",
            {
                '_token': $('input[name="_token"]', form).val(),
                '_user_id': $('input[name="_user_id"]', form).val(),
                '_goal_slug': goal_slug,
                'photo_ids': photo_ids,
                'message': $('textarea[name="message"]', form).val(),
            },
            function (response) {

                $('textarea[name="message"]', form).val('').attr('disabled', false);
                $('button[name="post_goal"]').attr('disabled', false);

                if (response.success == false) {
                    systemalert(response.message, 'warning');
                }

            }.bind(this),
            'json'
            )
            .fail(function () {
                $(this).attr('disabled', false);
                systemalert('There was an system error, please notify an admin!', 'danger');
            })
    }

});